let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gQPNg")).then(() => parcelRequire('8VjjG'));